import { useMemo } from 'react';
import { useMatches } from 'react-router';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const schema = z.object({
  inlineChangeHistory: z.literal(true),
});

export function useInlineChangeHistory() {
  const matches = useMatches();

  return useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return true;
      }
    }

    return false;
  }, [matches]);
}
